
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorRemovePointIcon as ObiCursorRemovePointIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-remove-point-icon.js';
 
 
 

 
 export const ObiCursorRemovePointIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-remove-point-icon',
   elementClass: ObiCursorRemovePointIconElement,
   events: {
     
   }
  });
 
 